import { createStandardAction } from 'typesafe-actions'
import { FilterState } from 'components/filter/reducer'
import { ReaderAnswerList } from 'types/ReaderAnswerList'

export const postDataToWorker = createStandardAction('@worker/data/set')<{
  allData: ReaderAnswerList
  filterState: FilterState
}>()
